/**
 * @module app.core
 */

import { autoinject, transient } from "aurelia-framework";
import { Api } from 'app/shared/lib/essette-api';
import { StandardLoadOptions } from 'app/shared/lib/essette-site';
import { IApiQueryResults, IApiActionResults } from 'app/shared/lib/api/api-types';
import * as Core from 'app/core/models/essette-api';

export interface IImportHistoryOrderBy {
    property: string;
    descending?: boolean | null;
}

export interface IImportHistorySearchFilters {
    jobStagedStartDate?: string | null;
    jobStagedEndDate?: string | null;
    jobCompletedStartDate?: string | null;
    jobCompletedEndDate?: string | null;
    stagedJobIdentifier?: string | null;
    systemCode?: string | null;
    profileKeys?: string[] | null;
    tenantKeys?: string[] | null;
    sectionKeys?: string[] | null;
    statuses?: Core.ImportStatus[] | null;
    orderBy?: {
        jobs?: IImportHistoryOrderBy[];
        tenants?: IImportHistoryOrderBy[];
        tables?: IImportHistoryOrderBy[];
    } | null;
    paging?: {
        top?: number | null;
        skip?: number | null;
    }
}

@transient()
@autoinject
export class ImportsService {

    ////****************** Fields and Properties ************************************////


    ////****************** Functions ************************************************////
    constructor(private readonly api: Api) { }


    ////****************** General **************************************************////


    ////****************** Loads ****************************************************////

    /**
     * Load all `Core.ImportHistory` models
     * @param queryParams query parameters for load
     */
    public async loadImportHistory(queryParams: IImportHistorySearchFilters): Promise<IApiActionResults> {
        const action = this.api.action('load', `import/history/`, queryParams);

        return await this.api.post(action);

    }

    public async loadImportStatuses(): Promise<IApiQueryResults<Core.ImportStatus>> {
        const query = this.api
            .query(`import/statuses`)
        return await this.api.get(query);
    }

    public async loadImportTenants(): Promise<IApiQueryResults<Core.ImportTenant>> {
        const query = this.api
            .query(`import/tenants`)
        return await this.api.get(query);
    }

    public async loadPolicyProfiles(options?: StandardLoadOptions): Promise<IApiQueryResults<Core.PolicyProfile>> {
        const query = this.api
            .query(`policies/profiles`)
            .applyStandardLoadOptions(options)
        return await this.api.get(query);
    }

    public async loadPolicySections(): Promise<IApiQueryResults<Core.PolicySection>> {
        const query = this.api
            .query(`policies/sections`)
        return await this.api.get(query);
    }

    /**
     * Load imports date
     * @param queryParams query parameters for load
     */
    public async loadPendingImports(queryParams: Core.PolicySection): Promise<IApiActionResults> {
        const action = this.api.action('load', `policies/sections/`, queryParams);

        return await this.api.post(action);

    }


    ////****************** Actions **************************************************////

    public async removeImportHistory(importHistory: Core.ImportHistory): Promise<IApiActionResults> {
        const action = this.api.action('remove', `import/History/`, importHistory);

        return await this.api.post(action);
    }

    public async resetImportHistory(importHistory: Core.ImportHistory): Promise<IApiActionResults> {
        const action = this.api.action('reset', `import/History/`, importHistory);

        return await this.api.post(action);
    }

}
